import React, {useState, useEffect, useRef} from 'react';
import { 
    Flex, Text, Center, Button, IconButton, Divider, Link, Image, useToast,
} from '@chakra-ui/react';
import { useNavigate } from "react-router-dom"
import { useCookies } from "react-cookie";
import axios from 'axios';
import fetch from "node-fetch"
import { GoogleLogin, useGoogleLogin, googleLogout } from "@react-oauth/google";
import { LoginButton } from "@telegram-auth/react"
import { MdSettings } from 'react-icons/md';
import { FaGoogle, FaTelegramPlane, FaDiscord, FaTelegram, FaTwitter } from 'react-icons/fa';
import { BsTwitterX } from 'react-icons/bs';
import "../../styles/index.scss";
const MAIN_COLOR = "black";

function LoginForm({ }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const [googleLoginResponse, setGoogleLoginResponse] = useState(null);
    const [googleLoginError, setGoogleLoginError] = useState(null);
    const navigate = useNavigate();
    const toast = useToast();

    useEffect(() => {
        if(cookies.loginCookie) {
            navigate("/");
        }
        // console.log("--- testGraphQL")
        // testGraphQL();
    }, []);

    useEffect(() => {
        if(googleLoginError) {
            toast({
                description: googleLoginError,
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
            setGoogleLoginError(null);
        }
    }, [googleLoginError]);
        

    useEffect(
        () => {
            if(googleLoginResponse) {
                axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${googleLoginResponse.access_token}`, {
                    headers: {
                        Authorization: `Bearer ${googleLoginResponse.access_token}`,
                        Accept: 'application/json'
                    }
                })
                .then(async(res) => {
                    if(res.data) {
                        const { email, name, id, picture, verified_email } = res.data;
                        const loginWithGoogleAuthRes = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/account/login_with_google_auth`, 
                            {
                                "email": email,
                                "accountInformation": {
                                    "username": name, 
                                    "photo_url": picture 
                                }
                            }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });

                        if(loginWithGoogleAuthRes.data?.error) {
                            toast({
                                description: loginWithGoogleAuthRes.data?.error,
                                status: "error",
                                duration: 3000,
                                isClosable: true,
                                position: "bottom-right"
                            });
                        } else {
                            setCookie("loginCookie", loginWithGoogleAuthRes.data?.data, { path: '/', maxAge: (24*60*60) });
                            navigate("/");
                        }
                    } else {
                        setGoogleLoginError(`Login by Google account failed!`);
                    }
                })
                .catch((err) => {
                    setGoogleLoginError(`Login by Google account failed!`);
                })
            }
        },
        [googleLoginResponse]
    )

    const testGraphQL = async() => {
        // const res = await axios.post('http://localhost:7000/', JSON.stringify(
        //     {
        //         query: `
        //             query {
        //                 get_accounts {
        //                     id
        //                     googleEmail
        //                 }
        //             }
        //         `
        //     },
        //     {
        //         headers: {
        //             'content-type': 'application/json',
        //         },
        //     }
        // ));

        // console.log("--- res", res)
        // const res = await fetch('http://localhost:7000/', {
        //     method: 'POST',
        //     headers: {
        //     'content-type': 'application/json',
        //     },
        //     body: JSON.stringify({
        //     query: `
        //         query {
        //             get_accounts {
        //                 id
        //                 googleEmail
        //             }
        //         }
        //     `,
        //     }),
        // });

        const res = await fetch('http://localhost:7000/', {
            method: 'POST',
            headers: {
            'content-type': 'application/json',
            },
            body: JSON.stringify({
            query: `
                query {
                    login_with_google_auth(email:"nguyenducngochoang@gmail.com") {
                        id
                        googleEmail
                    }
                }
            `,
            }),
        });

        const data = await res.json();

        console.log("--- data", data)
    }

    const handleGoogleLogin = useGoogleLogin({
        onSuccess: (res) => {
            setGoogleLoginResponse(res);
        },
        onError: (err) => {
            console.log("---- onError", err)
            setGoogleLoginError(`Login by Google account failed!`);
        }
    })
    
    const handleTelegramLogin = async(data) => {
        const { id, username, first_name, photo_url } = data;
        const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/account/login_with_telegram`, 
            {
                "telegramId": id,
                "accountInformation": { username, first_name, photo_url }
            }, {
            auth: {
                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
            }
        });

        if(res.data?.error) {
            toast({
                description: res.data?.error,
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        } else {
            setCookie("loginCookie", res.data?.data, { path: '/', maxAge: (24*60*60) });
            navigate("/");
        }
    }

    return (
        <Flex flexDirection="column" w="full" h="100vh" align="center" paddingX={{ base: 4, md: 16, lg: 16 }} paddingY={{ base: 2, md: 8, lg: 8 }} bg="black">
            <Flex w="full" h="10vh" align="center" justify="space-between">
                <Text className='one-font' fontSize="18px" color="white">ONE TOKEN</Text>
                <Button size="sm" borderColor="white" borderWidth="1px" backgroundColor="transparent" color="white">
                    <Text fontSize="2xs" textTransform="uppercase">learn more</Text>
                </Button>
            </Flex>
            
            <Flex flexDirection="row" w="fit-content" padding={2} mt={{ base: 2, md: 12, lg: 12 }} 
                borderColor="white" borderWidth="1px" borderRadius={4} backgroundColor="gray.700" color="white"
            >
                Special limited-time program: <strong>Earn 50% on ALL NEW ONE Referrals</strong>
            </Flex>

            <Flex flexDirection="column" w={{ base: "100%", md: "400px", lg: "400px" }} h={{ base: "60%", md: "450px", lg: "450px" }} 
                px={8} py={{ base: 2, md: 6, lg: 6 }} mt={{ base: 2, md: 12, lg: 12 }} justify="center" 
                borderColor="white" borderWidth="1px" borderRadius={4} backgroundColor={MAIN_COLOR} color="white"
            >
                <Text align="center" fontSize="18px" color="white" className='one-font'>ONE TOKEN</Text>
                <Text mt={8} align="center" fontSize="sm" color="white">Start trading immediately</Text>
                <Text mt={2} align="center" fontSize="10px" color="gray.300">Most efficient trading platform for solana memecoins.</Text>
                {/* <Button mt={8} mx="auto" colorScheme="blue" w="220px">
                    <FaTelegramPlane /> <Text ml={2} fontSize="12px" color="white">Login with Telegram</Text>
                </Button> */}
                <Center my={2}>
                    {/* <Text mt={8} align="center" fontSize="sm" color="white">{process.env.REACT_APP_TELEGRAM_BOT_NAME}</Text> */}
                    <LoginButton 
                        botUsername={process.env.REACT_APP_TELEGRAM_BOT_NAME}
                        buttonSize='large'
                        cornerRadius={5}
                        showAvatar={true}
                        lang='en'
                        onAuthCallback={(data) => {
                            // console.log(data)
                            handleTelegramLogin(data);
                        }}
                    />
                </Center>

                <Divider mx="auto" mt={4} w="220px"/>
                <Button mt={4} mx="auto" colorScheme="gray" color="black" w="220px" onClick={handleGoogleLogin}>
                    <Image alt="solana" src="/assets/icons/google.svg" width={19.2} height={19.2}/> <Text ml={2} fontSize="12px">Login with Google</Text>
                </Button>
            </Flex>

            <Flex flexDirection="row" w="full" justify="center" align="center" position="fixed" bottom={{ base: 4, md: 16, lg: 16 }} gap={2}>
                <Link href='#' textColor="white" textDecoration="underline" fontSize="12px">Privacy Policy</Link>
                <Text>|</Text>
                <Link href='#' textColor="white" textDecoration="underline" fontSize="12px">How to use</Link>
                <Text>|</Text>
                <IconButton minW={4} variant="ghost" _hover="transparent" colorScheme="whiteAlpha" icon={<FaDiscord />} />
                <IconButton minW={4} variant="ghost" _hover="transparent" colorScheme="whiteAlpha" icon={<BsTwitterX />} />
                <IconButton minW={4} variant="ghost" _hover="transparent" colorScheme="whiteAlpha" icon={<FaTelegram />} />
            </Flex>
        </Flex>
    )
}

export default LoginForm;